export default __webpack_public_path__ + "static/media/soundcard.0678b679.png";